// extracted by mini-css-extract-plugin
export var container = "_54-0";
export var fallback = "_54-5";
export var fallbackIcon = "_54-6";
export var hidden = "_54-2";
export var image = "_54-3";
export var loaded = "_54-4";
export var placeholder = "_54-1";